import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const HotDrinks = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Гарячi напоi'/>
            <main className={s.main}>
                <p>Кава</p>
                <Product name='Банановий коктейль' price='60 грн.' weight='280мл./' info1='банан, молоко, банановий сироп, вершки, банановий топінг'/>
                <Product name='Гарячий шоколад ' price='40 грн.'  weight='200мл.'/>
                <Product name='Какао' price='35 грн.' weight='300мл.' info1='Добавки:' info2='маршмеллоу - 10г/9 грн' info3='шоколадні дропси - 5г/9 грн'/>
                <Product name='Пряний апельсин' price='60 грн.' weight='280мл.' info1='яблучний сік, журавлинний морс, апельсин, лайм, грейпфрут, паличка кориці, цукровий сироп'/>
                <Product name='Глінтвейн (безалкогольний)' price='90 грн.' weight='300мл.' info1='яблучний сік, гранатовий сік, апельсин, лимон, мед, кардамон, бадьян, гвоздика, паличка кориці'/>
            </main>
        </div>
    )
}

export default HotDrinks;